import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../../../node_modules/classnames/index.js';
import Button from '../../Button/Button.js';
import DeleteIcon from '../../../GoogleIcons/Outlined/DeleteIcon.js';
import EditIcon from '../../../GoogleIcons/Outlined/EditIcon.js';
import { getItemId, isDisabled, isUpdateEnabled } from './listUtils.js';
import useKeepElementVisible from './useKeepElementVisible.js';

/**
 * Lista degli elementi
*/
function List({ className = undefined, current = undefined, onUpdateItem = undefined, onRemoveItem = undefined, onShowLastItem = undefined, itemKeyProperty = undefined, items, onSelected, renderItem, }) {
    useKeepElementVisible(items, itemKeyProperty, onShowLastItem, current);
    return (jsxs("ol", { className: cns('v2-select-field__items', className), tabIndex: -1, children: [items.map((item) => {
                const key = getItemId(item, itemKeyProperty);
                const disabled = isDisabled(item);
                return (jsxs("li", { id: key, className: cns('v2-select-field__item', {
                        'v2-select-field__item--selectable': !!onSelected,
                        'v2-select-field__item--selected': current === item,
                        'v2-select-field__item--disabled': disabled,
                    }), onClick: (event) => {
                        if (!disabled) {
                            onSelected(item, event);
                        }
                    }, children: [renderItem(item), (onUpdateItem || onRemoveItem) && isUpdateEnabled(item) && !disabled
                            && (jsxs("div", { className: "v2-select-field__item-actions", children: [onUpdateItem && (jsx(Button, { onClick: (event) => {
                                            event.stopPropagation();
                                            onUpdateItem(item, event);
                                        }, children: jsx(EditIcon, {}) })), onRemoveItem && (jsx(Button, { onClick: (event) => {
                                            event.stopPropagation();
                                            onRemoveItem(item, event);
                                        }, children: jsx(DeleteIcon, {}) }))] }))] }, key));
            }), items.length === 0
                && (jsx("div", { className: "v2-select-field__items-empty", children: "Nessun risultato per questa ricerca" }))] }));
}

export { List as default };
